/* tslint:disable */
import {Injectable} from '@angular/core';

declare function generateRandomHexColor(): any;

@Injectable({
    providedIn: 'root'
})
export class MarkersColorsService {
    defaultLinesColors;
    shareViewLinesColors;

    constructor() {
        this.defaultLinesColors = {
            0: {
                color: '#00ff00',
                isFree: true
            },
            1: {
                color: '#ff00ff',
                isFree: true
            },
            2: {
                color: '#00ffff',
                isFree: true
            },
            3: {
                color: '#ff0000',
                isFree: true
            },
            4: {
                color: '#0000ff',
                isFree: true
            },
            5: {
                color: '#ffff00',
                isFree: true
            },
            6: {
                color: '#ff8c00',
                isFree: true
            },
            usedColorsCount: 0
        }
    }

    getLineColor() {
        if (this.defaultLinesColors.usedColorsCount === 7) {
            return generateRandomHexColor();
        } else {
            for (let i = 0; i < 7; i++) {
                if (this.defaultLinesColors[i].isFree) {
                    this.defaultLinesColors[i].isFree = false;
                    this.defaultLinesColors.usedColorsCount += 1;
                    return this.defaultLinesColors[i].color;
                }
            }
        }
    }

    freeLineColor(hexName) {
        for (let i = 0; i < 7; i++) {
            if (this.defaultLinesColors[i].color === hexName) {
                this.defaultLinesColors[i].isFree = true;
                this.defaultLinesColors.usedColorsCount -= 1;
                break;
            }
        }
    }

    setLineColorOfShareView(colors) {
        this.shareViewLinesColors = {}
        this.shareViewLinesColors['usedColorsCount'] = 0;
        this.shareViewLinesColors['totalColorsCount'] = colors.length;
        for (let i = 0; i < colors.length; i++) {
            this.shareViewLinesColors[i] = {
                color: colors[i],
                isFree: true
            };
        }
    }

    getLineColorOfShareView() {
        let totalColorsCount = this.shareViewLinesColors.totalColorsCount;
        if (this.shareViewLinesColors.usedColorsCount === totalColorsCount) {
            return this.getLineColor();
        } else {
            for (let i = 0; i < totalColorsCount; i++) {
                if (this.shareViewLinesColors[i].isFree) {
                    this.shareViewLinesColors[i].isFree = false;
                    this.shareViewLinesColors.usedColorsCount += 1;
                    return this.shareViewLinesColors[i].color;
                }
            }
        }
    }
}
